import { Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import './style.css'

const Tabs = ({ data, selectedTab }) => {
    const [tabs, setTabs] = useState([])
    const [activeTab, setActiveTab] = useState(null)

    const handleSelectedTab = (userSelectedTab) => {
        setActiveTab(userSelectedTab)
    }

    useEffect(() => {
        if (data && data.length){
            setTabs(data)

            if(selectedTab && data.length){
                setActiveTab(data.filter(e=>e.label.toLowerCase() == selectedTab)[0])
            }
            else {
                setActiveTab(data[0])
            }
        } 
    }, [data])

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <Card bordered={false} className='p-0 mb-4' id='tabs'>
                        <div className="lg:w-1/4 md:w-2/4 w-full">
                            <div className="flex sm:flex-nowrap flex-wrap">
                                {tabs.map((tab) => (
                                    <div key={tab?.id}>
                                        <button
                                            key={tab?.id}
                                            onClick={() => handleSelectedTab(tab)}
                                            className={`relative lg:mr-8 md:mr-8 lg:px-2 md:px-2 px-[6px] py-2 sm:pb-4 pb-3 whitespace-nowrap transition 
                                                ${activeTab?.id == tab?.id ? ' text-black font-bold' : 'text-slate-500'}`
                                            }
                                        >   
                                            {tab?.label}
                                            {activeTab?.id == tab?.id && (
                                                <span
                                                    className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1/2 h-1 bg-yellow-400 transition-all duration-300 ease-in-out"
                                                ></span>
                                            )}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card>
                </Col>
                { activeTab && activeTab.content }
            </Row>
        </React.Fragment>
    );
};

export default Tabs;    
